import axios from "axios";
import { showLoader, hideLoader } from "../../redux/slice/loaderSlice";

const axiosPublic = axios.create({
  base_url: process.env.REACT_APP_BASE_URL,
});

// Request interceptor
axiosPublic.interceptors.request.use(
  async (config) => {
    const { Store } = await import("../../redux/Store");
    Store.dispatch(showLoader());
    config.headers["ngrok-skip-browser-warning"] = "true";
    return config;
  },
  async (err) => {
    const { Store } = await import("../../redux/Store");
    Store.dispatch(hideLoader());
    throw err;
  }
);

// Response interceptor
axiosPublic.interceptors.response.use(
  async (response) => {
    const { Store } = await import("../../redux/Store");
    Store.dispatch(hideLoader());
    return response;
  },
  async (err) => {
    const { Store } = await import("../../redux/Store");
    Store.dispatch(hideLoader());
    throw err;
  }
);

export default axiosPublic;
